import { getTokens } from 'core/classes/helpers/StorageHelper'
import Logger from 'core/utils/Logger'
import settings from 'src/config/settings'

export interface WidgetTourRaw {
  entryId: number
  widgetId: string
  tourConfig: string
  pageId: string
}

export interface WidgetToursResponse {
  status: string
  data: WidgetTourRaw[] | null
}

export const fetchWidgetTours = async (
  widgetId: string,
  signal?: AbortSignal
): Promise<WidgetToursResponse | null> => {
  const url = `${settings.httpsServices.partner360}/api/v0/widgetTours/getTours`
  const [accessToken] = getTokens()

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ widgetId }),
      signal,
    })

    if (!response.ok) {
      return null
    }

    return response.json()
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      return null
    }

    Logger.error(`Fail to fetch widget tours: ${widgetId}`)
    return null
  }
}
